import { render, staticRenderFns } from "./modulo1.vue?vue&type=template&id=3f85f254&scoped=true&"
import script from "./modulo1.vue?vue&type=script&lang=js&"
export * from "./modulo1.vue?vue&type=script&lang=js&"
import style0 from "./modulo1.vue?vue&type=style&index=0&id=3f85f254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85f254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Backup_Juan/ecopetrol/Cursos 2019/hidrocarburos/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
